// Product Price Range Fetcher
async function getProductPriceRange(productHandle) {
  try {
    const response = await fetch(`/products/${productHandle}.price-range.json`);
    if (!response.ok) throw new Error('Product not found');
    const data = await response.json();
    return data.product.price_range;
  } catch (error) {
    console.error('Error fetching price range:', error);
    return null;
  }
}

// Size Options with Dynamic Price Updater
function initializeSizeOptionsWithPrices() {
  // Wait for variant picker to load
  document.addEventListener('variant:change', function(event) {
    updateSizeOptionPrices(event.detail.variant);
  });
  
  // Initial setup
  const variantPicker = document.querySelector('variant-picker');
  if (variantPicker) {
    const selectedVariant = JSON.parse(variantPicker.querySelector('[data-selected-variant]').textContent);
    updateSizeOptionPrices(selectedVariant);
  }
}

// Update price next to size options
function updateSizeOptionPrices(variant) {
  document.querySelectorAll('.size-price-container .current-price').forEach(priceEl => {
    // Update price based on selected variant
    // Add your logic here
  });
}

// Initialize on page load
document.addEventListener('DOMContentLoaded', function() {
  initializeSizeOptionsWithPrices();
});